/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Merchant } from "../../../../models";

@Component({
  selector: "app-fraud-and-risk-edit",
  templateUrl: "./fraud-and-risk-edit.component.html"
})
export class FraudAndRiskEditComponent {
  @Input("parentGroup") parentGroup!: FormGroup;
  @Input("merchant") merchant!: Merchant;

  get fraudRiskFormControls() {
    return this.parentGroup.controls;
  }
}
